const State = {
  transferAccountList: [],
  maxSortNumber: 0
}

export default State
